import React, { useEffect, useState } from 'react'
import Button2 from '../../Buttons/Button2/Button2'
import AnimateOnScroll from '../../ScrollAnimations/AnimateOnScroll'

const words = ["App Development", "Web Development", "API Development"]; // Fixed typo from "Desinger"


const HomeComponent = () => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
                setFade(true);
            }, 500); // duration of fade-out
        }, 3000); // total interval time

        return () => clearInterval(interval);
    }, []);

    return (
        <div className='inner-home'>
            <div>
                <AnimateOnScroll>
                    <p className="base_heading_2">
                        Website Development Company <br></br> Built for High-Growth Brands
                    </p>
                    <p className="base_heading_2" id="words" style={{ opacity: fade ? 1 : 0, transition: 'opacity 0.5s ease-in-out' }}>{words[currentIndex]}</p>
                    <p className="base_p_tag">More than aesthetics. We build high-converting websites that speak to your audience and drive real business growth.</p>
                </AnimateOnScroll>

                <AnimateOnScroll>
                    <Button2 text="Explore Our Services" link="/services" />
                </AnimateOnScroll>

            </div>
        </div>
    )
}

export default HomeComponent